import Network from '@/services/network'

export default function handleDentalOs() {
    const network = new Network;

    const storeBill = (data) => {
        return network.api('post', '/dental-os/billing/create-bill', data);
    }

    const fetchSingleDoctorOrder = (query, id) => {
        return network.api('get', `/dental-os/dental-prescription/get-dental-prescription/${id}`+ query);
    }

    const fetchTreatmentPlan = (query) => {
        return network.api('get', `/dental-os/billing/treatment-list` + query);
    }

    const fetchServiceList = (query) => {
        return network.api('get', `/dental-os/billing/treatment-service-list` + query);
    }

    const storeDentalPrescription = (data) => {
        return network.api('post', '/dental-os/dental-prescription/store-dental-prescription', data);
    }

    const updateDentalPrescription = (data, id) => {
        return network.api('post', '/dental-os/dental-prescription/update-dental-prescription/' + id, data);
    }

    const fetchDentalScheduleList = (query) => {
        return network.api('get', `/dental-os/dental-schedule` + query);
    }
    const fetchSingleDentalSchedule = (query, activityId) => {
        return network.api('get', `/dental-os/dental-schedule/${activityId}`+ query);
    }

    const updateIPDSettlementStatus = (id, data) => {
        return network.api('post', '/dental-os/billing/ipd-settlement-status/' + id, data);
    }

    const updateDragDropDentalSchedule = (id, data) => {
        return network.api('post', '/dental-os/update-dental-schedule-drag-drop/' + id, data);
    }

    const storeTask = (data) => {
        return network.api('post', '/dental-os/service-task/store-task', data);
    }

    const updateTask = (data, id) => {
        return network.api('post', '/dental-os/service-task/update-task/' + id, data);
    }

    const deleteTask = (id, query) => {
        return network.api('post', '/dental-os/service-task/delete-task/' + id + query);
    }

    const fetchSingleTask = (id, query) => {
        return network.api('get', '/dental-os/service-task/get-single-task/' + id + query);
    }

    return {
        storeBill,
        fetchSingleDoctorOrder,
        fetchServiceList,
        storeDentalPrescription,
        updateDentalPrescription,
        fetchTreatmentPlan,
        fetchDentalScheduleList,
        fetchSingleDentalSchedule,
        updateIPDSettlementStatus,
        updateDragDropDentalSchedule,
        storeTask,
        updateTask,
        deleteTask,
        fetchSingleTask
    }
}